import { getAdvantageIcon } from '@components/AutoComplete/AutoCompleteAdvantages';
import FormContainer from '@components/FormContainer';
import { CustomIcon } from '@components/Icons';
import { Article } from '@components/InputRichText';
import JobOfferWhyChooseUsForm from '@modules/JobOffers/JobOfferDetail/components/JobOfferWhyChooseUsForm';
import { useOptionsContext } from '@modules/talents/context/options-context';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';


const JobOfferWhyChooseUs = ({ pro, jobOffer, onSubmit, loading }: { pro: any, jobOffer: any, onSubmit?: () => Promise<void>, loading?: boolean }) => {
    
        const { data: optionsData } = useOptionsContext();
        const options = useMemo(() => optionsData?.options, [optionsData]);
        const { getValues } = useFormContext();
        
    const [formState, setFormState] = useState<'view' | 'edit'>('view');

    const handleCancel = () => {
        setFormState('view');
    };

    const handleSubmit = async () => {
        await onSubmit?.();
        setFormState('view');
    }

    return (
        <FormContainer
            formTitle="Pourquoi nous choisir ?"
            formState={formState}
            setFormState={setFormState}
            loading={loading}
            onCancel={handleCancel}
            onSubmit={handleSubmit}
        >
            {formState === 'view' ? (
                <Box display="flex" flexDirection="column" gap="24px">
                    {/* Header Section */}
                    <Box display="flex" flexDirection="column" gap="8px">
                         <Article
                            dangerouslySetInnerHTML={{ __html: getValues('description.advantages') }}
                        />
                    </Box>

                    {/* Benefits Grid */}
                    <Grid container spacing={2}>
                        {getValues('description.listAdvantages')?.map((item, index) => {
                            const advantage = (options?.advantages?.[0]?.children ?? [])?.find(
                                advantage => advantage.name === item,
                            );

                            return (
                                <Grid item xs={6} sm={4}>
                                    <Stack gap={2} flexWrap={'wrap'} alignItems={'center'} justifyContent={'center'}>
                                        {advantage?.icon && (
                                            <CustomIcon size={32} color="#fff" name={getAdvantageIcon(advantage?.icon)} />
                                        )}
                                        <Typography textAlign="center">
                                            {advantage?.name}
                                        </Typography>
                                    </Stack>
                                </Grid>
                            );
                        })}
                    </Grid>
                </Box>) : (
                <JobOfferWhyChooseUsForm />
            )}
        </FormContainer>
    );
};

export default JobOfferWhyChooseUs;
